<template>
  <v-dialog :model-value="show" max-width="800" persistent @update:model-value="$emit('close')">
    <v-card>
      <v-card-title class="bg-primary text-white">
        <v-icon class="mr-2">mdi-bell-outline</v-icon>
        {{ isEditing ? 'Edit Notification Template' : 'Add Notification Template' }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localForm.event_name"
              label="Event Name"
              hint="Machine name, e.g. quarantine_started"
              persistent-hint
              density="compact"
              :disabled="isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localForm.event_label"
              label="Event Label"
              hint="Human-readable name"
              persistent-hint
              density="compact"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="localForm.event_category"
              :items="categories"
              label="Event Category"
              density="compact"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              v-model="localForm.active"
              label="Active"
              color="success"
              density="compact"
              hide-details
            />
          </v-col>
        </v-row>

        <v-divider class="my-3" />
        <div class="text-subtitle-2 mb-2">In-App Notification</div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="localForm.notification_subject"
              label="Notification Subject"
              density="compact"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="localForm.notification_body"
              label="Notification Body"
              rows="3"
              density="compact"
              auto-grow
            />
          </v-col>
        </v-row>

        <v-divider class="my-3" />
        <div class="text-subtitle-2 mb-2">Email Notification</div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="localForm.email_subject"
              label="Email Subject"
              density="compact"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="localForm.email_body"
              label="Email Body"
              rows="4"
              density="compact"
              auto-grow
            />
          </v-col>
        </v-row>

        <v-divider class="my-3" />
        <div class="text-subtitle-2 mb-2">Available Variables</div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="localForm.available_variables"
              label="Available Variables"
              hint="Comma-separated list of {variable} placeholders"
              persistent-hint
              density="compact"
            />
          </v-col>
          <v-col cols="12" v-if="localForm.available_variables">
            <div class="d-flex flex-wrap ga-1">
              <v-chip
                v-for="v in parsedVariables"
                :key="v"
                size="small"
                variant="outlined"
                color="primary"
                @click="copyVariable(v)"
              >
                {{ v }}
                <v-icon end size="x-small">mdi-content-copy</v-icon>
              </v-chip>
            </div>
            <div class="text-caption text-grey mt-1">Click a variable to copy it</div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">
          {{ isEditing ? 'Update' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NotificationTemplateDialog',
  props: {
    show: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    formData: { type: Object, default: () => ({}) },
    saving: { type: Boolean, default: false }
  },
  emits: ['close', 'save'],
  data() {
    return {
      localForm: { ...this.formData },
      categories: ['quarantine', 'termination', 'renewal', 'billing', 'general']
    };
  },
  computed: {
    parsedVariables() {
      if (!this.localForm.available_variables) return [];
      return this.localForm.available_variables.split(',').map(v => v.trim()).filter(v => v);
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.localForm = { ...val };
      },
      deep: true
    },
    show(val) {
      if (val) {
        this.localForm = { ...this.formData };
      }
    }
  },
  methods: {
    save() {
      this.$emit('save', { ...this.localForm });
    },
    copyVariable(v) {
      navigator.clipboard.writeText(v);
    }
  }
});
</script>
